module.exports = __webpack_public_path__ + "media/img/scholarships/English Year 10-f2405d5e123dc0e0f1f1b0c20029dbae.svg";